import {
    createCalculatedColumn,
    createColumn, createComponentColumn
} from "../../../utils/ColumnUtils";
import React from "react";
import {formatDate} from "../../../utils/DateUtils";
import {parseISO} from "date-fns";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import {
    BEAUFTRAGTER,
    BETREIBER,
    FACHADMIN,
    SYSTEMADMIN,
    ZUST_SBA,
    ZUST_SBB,
    ZUST_SBD,
    ZUST_SBS
} from "../../../consts/funktionaleRollen";
import {JahresberichtValues, StatusParameterMesswerte} from "../../../consts/valueLists";
import EAPaginatedTable from "../../EAPaginatedTable";
import EATableActionButton from "../../tableComponents/EATableActionButton";
import {Link} from "react-router-dom";
import {calculateJahresberichtLink} from "../../betriebsakte/jahresbericht/JahresberichtObjects";

export default function JahresberichtArbeitsListeTable({
                             id,
                             loading,
                             data,
                             history,
                             storedFilter,
                             setStoredFilter,
                             sharedFilter
                         }) {
    const getStatusValue = (id) => {
        const statusObj = JahresberichtValues.find((status) => status.id === id);
        return statusObj ? statusObj.value : "";
    };

    const getStatusMesswerteValue = (id) => {
        const statusObj = StatusParameterMesswerte.find((status) => status.id === id);
        return statusObj ? statusObj.value : "";
    };

    const anlageColumns = [
        createComponentColumn(
            "actions",
            (row, index) => {
                return (
                    <div className="eatabwrapper">
                        {editAllowed() && (
                            <EATableActionButton id={"abs-" + index} iconName="ico-edit">
                                <Link to={calculateJahresberichtLink(row, "s")}/>
                            </EATableActionButton>
                        )}
                        <EATableActionButton id={"abl-" + index} iconName="ico-view">
                            <Link to={calculateJahresberichtLink(row)}/>
                        </EATableActionButton>
                    </div>
                );
            },
            "",
            null,
            {padding: 0, width: "50px", minWidth: "50px", maxWidth: "50px"}
        ),
        createCalculatedColumn(
            "von",
            (row) => (row?.von ? new Date(row.von).getFullYear() : null),
            "Berichtsjahr"
        ),
        createColumn("anlage.anlagenId", "Anlagennummer"),
        createColumn("anlage.bezeichnung", "Abwasseranlage"),
        createCalculatedColumn(
            "anlage.betrieb.betreiber.bezeichnung",
            (row) => row.anlage.organisation.value,
            "Betreiber"
        ),
        createCalculatedColumn(
            "anlage.betrieb.betriebstyp",
            (row) => row.anlage.betriebTyp.value,
            "Betriebstyp"
        ),
        createCalculatedColumn(
            "status",
            (row) => getStatusMesswerteValue(row.statusMesswerte),
            "Status Messwerte"
        ),
        createCalculatedColumn(
            "status",
            (row) => getStatusValue(row.status),
            "Status"
        )
    ];

    function editAllowed() {
        return userHasAnyRole([SYSTEMADMIN, FACHADMIN, BETREIBER, BEAUFTRAGTER, ZUST_SBD, ZUST_SBB, ZUST_SBS, ZUST_SBA]);
    }

    if ((sharedFilter.gueltigVon || sharedFilter.gueltigBis) && !sharedFilter.personalisiert) {
        anlageColumns.push(
            createCalculatedColumn(
                "auditInfo.gueltigAb",
                (row) => (row?.auditInfo?.gueltigAb ? formatDate(parseISO(row.auditInfo.gueltigAb)) : null),
                "Gültig von"
            )
        );
        anlageColumns.push(
            createCalculatedColumn(
                "auditInfo.gueltigBis",
                (row) => (row?.auditInfo?.gueltigBis ? formatDate(parseISO(row.auditInfo.gueltigBis)) : null),
                "Gültig bis"
            )
        );
    }

    return (
        <>
            <EAPaginatedTable
                id={id}
                loading={loading}
                columns={anlageColumns}
                data={data}
                onDoubleClick={(row) => {
                    history.push(calculateJahresberichtLink(row));
                }}
                onAltDoubleClick={(row) => {
                    if (editAllowed()) {
                        history.push(calculateJahresberichtLink(row, "s"));
                    }
                }}
                pageInfo={storedFilter.pageInfo}
                setPageInfo={(pageInfo) => {
                    setStoredFilter({...storedFilter, pageInfo});
                }}
            />
        </>
    );
}
